import moment from 'moment';

// FIXME: i18n
export const dateFormat = 'YYYY-MM-DD';
export const dateTimeFormat = 'YYYY-MM-DD HH:mm';

export const formatDate = (date?: Date): string | undefined => date && moment(date).format(dateFormat);
export const formatDateTime = (date?: Date): string | undefined => date && moment(date).format(dateTimeFormat);
